import {
    apiRequest,
    masterRank,
    masterEducation,
    masterEducationGroup,
    masterEchelon,
    masterPosition,
    masterPositionGrade,
    masterWorkUnit,
    flexDownloadExcel
} from "../../../../../services/adapters/kepegawaian/flexyportService"

class IndexRepository {

    fetchRank = async (query) => {
        return await apiRequest("get", masterRank, {
            params: query
        }, true)
    }

    fetchEducation = async (query) => {
        return await apiRequest("get", masterEducation, {
            params: query
        }, true)
    }

    fetchEducationGroup = async (query) => {
        return await apiRequest("get", masterEducationGroup, {
            params: query
        }, true)
    }

    fetchEchelon = async (query) => {
        return await apiRequest("get", masterEchelon, {
            params: query
        }, true)
    }

    fetchPosition = async (query) => {
        return await apiRequest("get", masterPosition, {
            params: query
        }, true)
    }

    fetchPositionGrade = async (query) => {
        return await apiRequest("get", masterPositionGrade, {
            params: query
        }, true)
    }

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }

    fetchDownloadExcel = async (query) => {
        return await apiRequest("get", flexDownloadExcel, {
            params: query
        }, true)
    }
}

export default IndexRepository